import dispatcher from "../dispatcher";
import { transactionAccountConstant } from "../constants/constants";
import rq from "../components/utility/rq.js";
export function creatTrAccount(trAccount) {
    rq.post("/api/v1/transactionAcc", trAccount).then((data) => {
        trAccount.trAccId = data[0].lastId;
        dispatcher.dispatch({ type: transactionAccountConstant.TRANSACTIONACCOUNT_CREATED, trAccount });
    }).catch((data) => {
        dispatcher.dispatch({ type: transactionAccountConstant.TRANSACTIONACCOUNT_CREATION_FAILED, msg: `creating Transaction Account ${trAccount.trAccountName} failed ! ${data.responseText}` });
    });
}


export function fetchAllTrAccount() {
    rq.getJsonData("/api/v1/transactionAcc").then((data) => {
        dispatcher.dispatch({ type: transactionAccountConstant.FETCHED_ALL_TRANSACTIONACCOUNT, data });
    }).catch((data) => {
        dispatcher.dispatch({ type: transactionAccountConstant.TRANSACTIONACCOUNT_FETCH_FAILED, msg: `Fething Transaction Account failed ! ${data.responseText}` });
    });
}

export function fetchAllTrAccountPayMode() {
    rq.getJsonData("/api/v1/transaction-acc-detail").then((data) => {
        dispatcher.dispatch({ type: transactionAccountConstant.FETCHED_ALL_TRANSACTION_PAYMENT, data });
    }).catch(() => {
        alert("FALI TR Paymode");
    });
}


// WEBPACK FOOTER //
// ./src/jsx/actions/transaction-account-action.jsx